import { z } from 'zod';
export const userRoleSchema = z.enum([
    'owner',
    'admin',
    'operations',
    'finance',
    'sales_girl',
    'viewer',
    'driver',
]);
// Email is the login identifier; normalize case/whitespace so
// "Foo@X.com" and "foo@x.com" are treated as the same account.
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(8).max(128),
});
export const refreshSchema = z.object({
    refreshToken: z.string().min(1),
});
// Self-service "which shop am I at" switch — the target must be one of the
// caller's own allowed shops (home shop or an active assignment); enforced
// server-side, not by this shape.
export const setActiveShopSchema = z.object({
    shopId: z.string().min(1),
});
export const registerSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(8).max(128),
    name: z.string().min(1).max(120),
    role: userRoleSchema.optional(),
});
// ── two-factor (TOTP) ────────────────────────────────────────────────────────
const totpCodeSchema = z
    .string()
    .transform((s) => s.replace(/\s/g, ''))
    .pipe(z.string().regex(/^\d{6}$/, 'Enter the 6-digit code'));
export const totpLoginVerifySchema = z.object({
    challengeToken: z.string().min(1),
    code: totpCodeSchema,
});
export const totpEnableSchema = z.object({
    code: totpCodeSchema,
    // present when completing first-time enrolment during login; absent for a
    // voluntary setup by an already-signed-in user (auth via access token).
    challengeToken: z.string().optional(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(25),
});
//# sourceMappingURL=index.js.map